<script setup lang="ts">
import { bemBuilder } from "@chatfood/core-utils";
import { AtomText } from "@chatfood/design-system";
import { BasketItems } from "../basket-items";
import { useBasketStore } from "~/stores/basket";
import { useLocale } from "~/composables/use-locale";

const css = bemBuilder("basket-summary");

const basket = useBasketStore();

const { t } = useLocale();
</script>

<template>
  <div :class="css('')">
    <BasketItems :class="css('line')" />
    <div v-if="basket.notes" :class="css('order-notes')" data-test="order-note">
      <AtomText color="color-text-disabled" type="body-bold">
        {{ t("components.basket_summary.order_note") }}
      </AtomText>
      <AtomText :class="css('notes')" color="color-text-disabled" type="body">
        {{ basket.notes }}
      </AtomText>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.basket-summary {
  &__line {
    border-bottom: 1px solid var(--color-base-95);

    &:last-child {
      border: none;
    }
  }

  &__order-notes {
    padding: var(--spacing-md) 0;
    border-bottom: 1px solid var(--color-base-95);
  }

  &__notes {
    white-space: break-spaces;
    margin-left: var(--spacing-xs);
  }
}
</style>
